/**
 * staff-assist-lib.ts — Khối "AI hỗ trợ nhân viên" (Nguồn AI và lượt AI): model riêng cho từng việc hỗ trợ nhân viên
 * (`ai_configs.task_overrides`). CHỈ các việc dưới đây — model trả lời khách nay thuộc từng nhân viên AI, nên các khoá
 * `auto_reply`, `ai_router` không hiện ở đây và được GIỮ NGUYÊN khi lưu (không xoá dữ liệu cũ trước khi chuyển đổi).
 */
import { i18n } from '@/lib/i18n'
import type { TaskOverrides } from '@/hooks/use-ai'
import type { PickerValue } from '@/components/ai/ai-model-picker-lib'

export interface StaffTask {
  key: string
  /** Các khoá task_overrides cùng nhóm (ghi cùng một model). */
  keys: string[]
  icon: string
  name: string
  desc: string
}

export const STAFF_ASSIST_TASKS: StaffTask[] = [
  { key: 'reply_draft', keys: ['reply_draft'], icon: '💬', get name() { return i18n.t('aiOps:staffAssistLib.replyDraft.name') }, get desc() { return i18n.t('aiOps:staffAssistLib.replyDraft.desc') } },
  { key: 'summary', keys: ['summary', 'sentiment', 'lead_score'], icon: '📄', get name() { return i18n.t('aiOps:staffAssistLib.summary.name') }, get desc() { return i18n.t('aiOps:staffAssistLib.summary.desc') } },
  { key: 'ai_cdp', keys: ['ai_cdp'], icon: '🧠', get name() { return i18n.t('aiOps:staffAssistLib.aiCdp.name') }, get desc() { return i18n.t('aiOps:staffAssistLib.aiCdp.desc') } },
  { key: 'ai_master', keys: ['ai_master'], icon: '✨', get name() { return i18n.t('aiOps:staffAssistLib.aiMaster.name') }, get desc() { return i18n.t('aiOps:staffAssistLib.aiMaster.desc') } },
]

/** Khoá thuộc nhân viên AI (không sửa ở cấp tổ chức). */
export const BOT_OWNED_TASK_KEYS = ['auto_reply', 'ai_router'] as const

/** Model riêng của một việc (null = theo model mặc định). */
export function staffTaskValue(overrides: TaskOverrides | null | undefined, task: StaffTask): PickerValue | null {
  const o = overrides?.[task.key]
  return o?.provider && o?.model ? { provider: o.provider, model: o.model } : null
}

/** Ghi model của một việc vào TẤT CẢ khoá cùng nhóm; null = bỏ ghi đè. Không đụng khoá khác (vd auto_reply). */
export function applyStaffTask(overrides: TaskOverrides | null | undefined, task: StaffTask, v: PickerValue | null): TaskOverrides {
  const next: TaskOverrides = { ...(overrides ?? {}) }
  for (const k of task.keys) {
    if (!v?.provider || !v.model) delete next[k]
    else next[k] = { provider: v.provider, model: v.model }
  }
  return next
}
